import React from "react";
import { useTranslation } from "react-i18next";
import { Group, group } from "@planzone/dto";
import {
  useAddResourceGroup,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { GroupCreationForm } from "./groupCreationForm";
import { Props } from "./types";
import styles from "./styles.scss";

function PlanzoneResourceGroupCreation({ cancel }: Props) {
  const { planzone } = useRetrieveCurrentPlanzone();
  const { isRequestPending, addResourceGroup } = useAddResourceGroup(
    planzone.uuid,
  );
  const { t } = useTranslation();
  const [formData, setFormData] = React.useState<Group>({
    ...group,
    resourceType: "planzone",
  });

  return (
    <Modal
      header={t("addResourceGroup.title")}
      className={styles.groupCreation}
      close={cancel}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          addResourceGroup({ namespace: planzone.uuid, group: formData });
        }}
        className={styles.main}
      >
        <div className={styles.form}>
          <GroupCreationForm formData={formData} editForm={setFormData} />
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("addResourceGroup.cancel")}
          </Button>
          <Button
            status={isRequestPending ? "pending" : "none"}
            type={"submit"}
          >
            {t("addResourceGroup.create")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { PlanzoneResourceGroupCreation };
